import { Chip, Tooltip } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../../utils/GlobalContext";
import CalenderImg from "../../Assets/Img/calender.svg";
import LocationImg from "../../Assets/Img/Location.png";
import DummyImg from "../../Assets/Img/Rectangle 21.png";
import NoCamp from "../../Assets/Img/amico.svg";
import create from "../../Assets/Img/create dashboard.png";
import instagram from "../../Assets/Img/instagram.png";
// import Search from "../../Assets/Img/search.png";
import youtube from "../../Assets/Img/youtube.png";
import axiosMain from "../../http/axiosMain";
import "./Campaign.css";
import { SearchBar } from "../../Common/Components/SearchBar";
import youtubeDeliverables from "../../Assets/Img/youtube deliverables.svg";
import instaDeliverables from "../../Assets/Img/insta deliverables.svg";
import { Calendar } from "lucide-react";

export default function CampaignCreate({ id }) {
  const { userData } = useContext(GlobalContext);
  // const [currentStep, setCurrentStep] = useState(1);
  const [dataList, setDataList] = useState([]);
  // const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [showContent, setShowContent] = useState(false);
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  // const [filteredData, setFilteredData] = useState(data);
  // const location = useLocation();
  const [activeTab, setActiveTab] = useState("ongoing");
  const debounceTimeoutRef = useRef(null);
  const [tabData, setTabData] = useState({});
  const [campaignStatusCounts, setCampaignStatusCounts] = useState({});
  const [isCampaignStatusFetched, setIsCampaignStatusFetched] = useState(false);

  const statusTabs = {
    ongoing: "Ongoing Campaign",
    draft: "Save as Draft",
    scheduled: "Scheduled for Later",
    completed: "Completed Campaign",
  };
  // const [campaignCounts, setCampaignCounts] = useState({
  //   ongoing: 0,
  //   draft: 0,
  //   scheduled: 0,
  //   completed: 0,
  // });

  useEffect(() => {
    if (!tabData[activeTab]) {
      fetchData(activeTab);
    }
  }, [activeTab]);
  useEffect(() => {
    fetchData("ongoing");
  }, []);

  // Example of how to change the active tab
  // const handleTabChange = (newTab) => {
  //   setActiveTab(newTab);
  // };
  // const [loading, setLoading] = useState(true);
  useEffect(() => {
    const isDraft = JSON.parse(localStorage.getItem("saved_as_draft"));
    if (isDraft) {
      setActiveTab("recent");
    }
  }, []);

  // const [contentTypes, setContentTypes] = useState([
  //   {
  //     platform: "Instagram",
  //     items: [
  //       { id: "reels", label: "Reels", count: 1, checked: false },
  //       { id: "posts", label: "Posts", count: 1, checked: false },
  //       { id: "story", label: "Story", count: 1, checked: false },
  //     ],
  //   },
  //   {
  //     platform: "YouTube",
  //     items: [
  //       { id: "shorts", label: "Shorts", count: 1, checked: false },
  //       { id: "video", label: "Video", count: 1, checked: false },
  //       { id: "liveStream", label: "Live Stream", count: 1, checked: false },
  //     ],
  //   },
  // ]);

  // const handleIncrement = (platformIndex, itemIndex) => {
  //   const newContentTypes = [...contentTypes];
  //   newContentTypes[platformIndex].items[itemIndex].count += 1;
  //   setContentTypes(newContentTypes);
  // };

  // const handleDecrement = (platformIndex, itemIndex) => {
  //   const newContentTypes = [...contentTypes];
  //   const currentCount = newContentTypes[platformIndex].items[itemIndex].count;
  //   if (currentCount > 0) {
  //     newContentTypes[platformIndex].items[itemIndex].count -= 1;
  //     setContentTypes(newContentTypes);
  //   }
  // };

  // const handleCheckboxChange = (platformIndex, itemIndex) => {
  //   const newContentTypes = [...contentTypes];
  //   newContentTypes[platformIndex].items[itemIndex].checked =
  //     !newContentTypes[platformIndex].items[itemIndex].checked;
  //   setContentTypes(newContentTypes);
  // };

  // const handleNextbtn = () => {
  //   if (currentStep < totalSteps) {
  //     setCurrentStep((prevStep) => prevStep + 1);
  //   }
  // };

  // const handlePrevbtn = () => {
  //   if (currentStep > 1) {
  //     setCurrentStep((prevStep) => prevStep - 1);
  //   }
  // };
  // const handleStartDateChange = (e) => {
  //   setStartDate(e.target.value);
  //   setEndDate(""); // Reset end date when start date changes
  //   setShowContent(false);
  // };
  const formatSingleDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or invalid dates
    const date = new Date(dateString);

    // Ensure valid date
    if (isNaN(date.getTime())) return "";

    const day = date.getUTCDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getUTCFullYear();

    return `${day} ${month}, ${year}`;
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return "th"; // Special case for 11, 12, 13
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // const handleEndDateChange = (e) => {
  //   setEndDate(e.target.value);
  //   setLoading(true);
  //   setShowContent(false);

  //   setTimeout(() => {
  //     setLoading(false);
  //     setShowContent(true);
  //   }, 2000); // Show loader for 2 seconds
  // };

  // const currentDate = new Date().toISOString().split("T")[0];

  const totalSteps = 4;

  // const handleNext = () => {
  //   setCurrentStep((prev) => Math.min(prev + 1, totalSteps));
  // };

  // const handlePrev = () => {
  //   setCurrentStep((prev) => Math.max(prev - 1, 1));
  // };
  // const [selectedAge, setSelectedAge] = useState(null);

  // const ageGroups = [
  //   "13-17",
  //   "18-24",
  //   "25-34",
  //   "35-44",
  //   "45-54",
  //   "55-64",
  //   "65+",
  // ];

  // const handleAgeSelect = (age) => {
  //   setSelectedAge(age);
  // };

  // const handleSaveDraft = () => {
  //   // Log save draft response here
  //   console.log("Draft Saved:", {
  //     startDate,
  //     endDate,
  //     contentTypes,
  //     selectedAge,
  //   });
  // };

  console.log(dataList, "dataList");

  // const handlePublish = () => {
  //   // Log publish response here
  //   console.log("Campaign Published:", {
  //     startDate,
  //     endDate,
  //     contentTypes,
  //     selectedAge,
  //   });
  // };
  const ViewDetails = (id) => {
    navigate(`/campaign-details/${id}`, {
      state: { tabType: activeTab },
    });
  };

  const navigate = useNavigate();
  const createNavigate = () => {
    navigate("/campaign-create");
  };

  const fetchData = async (status = null, title = null) => {
    setLoading(true);
    setError(null);
    setSearchQuery("");
    try {
      const response = await axiosMain.get("/api/v1/campaigns", {
        params: {
          ...(status && { campaign_status: status }),
          ...(title && { campaign_title: title }),
        },
      });
      setDataList(response.data.campaigns);
    } catch (err) {
      console.error("Fetch error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(activeTab); // initial fetch or when tab changes
  }, [activeTab]);

  useEffect(() => {
    fetchData(activeTab);
  }, [activeTab]);

  useEffect(() => {
    const fetchCampaignStatusCounts = async () => {
      try {
        const response = await axiosMain.get("/api/v1/campaigns/status");
        const { status, isCampaignStatusFetched } = response.data;

        // remap savedDraft to draft
        const remappedStatus = {
          ongoing: status.ongoing || 0,
          draft: status.savedDraft || 0,
          scheduled: status.scheduled || 0,
          completed: status.completed || 0,
        };

        setCampaignStatusCounts(remappedStatus);
        setIsCampaignStatusFetched(isCampaignStatusFetched);
      } catch (error) {
        console.error("Error fetching campaign status counts:", error);
      }
    };

    fetchCampaignStatusCounts();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500">
          Loading...
        </div>
      </div>
    );
  }
  // const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD in local time

  // const recentCampaigns = data?.filter(
  //   (ele) => ele.camping_created_date.split("T")[0] === today
  // );

  const handleSearch = (query) => {
    // const query = e.target.value;
    setSearchQuery(query);

    // Clear previous timeout if still waiting
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    // Set new debounce timeout
    debounceTimeoutRef.current = setTimeout(() => {
      performSearch(query);
    }, 2000); // 2 seconds
  };

  const performSearch = async (query) => {
    try {
      if (query?.trim().length > 0) {
        setLoading(true);
        const response = await axiosMain.get("/api/v1/campaigns", {
          params: { campaign_title: query },
        });
        setDataList(response.data.campaigns);
      } else {
        fetchData(activeTab); // initial fetch or when tab changes
        // fetchData(); // Fetch all if input is empty
      }
    } catch (err) {
      console.error("Search error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="campaignCreate">
        <div className="SearchFilterSection">
          <div className="d-flex justify-content-end align-items-center w-100">
            {dataList?.length > 0 ? (
              <>
                {/* Search Bar on Top Left */}
                <div className="Campaign SearchInput d-flex align-items-center">
                  {/* <img
                    src={Search}
                    className="img-fluid me-2"
                    alt="Search Icon"
                    style={{ width: "20px", height: "20px" }}
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearch}
                  /> */}
                  <SearchBar
                    searchQuery={searchQuery}
                    setSearchQuery={handleSearch}
                  />
                </div>

                {/* Create Button on Top Right (only for brand role) */}

                <div>
                  <button
                    onClick={() => createNavigate()}
                    className="CreateGreenBtn"
                  >
                    Create new Campaign
                    <img src={create} className="img-fluid" alt="Create Icon" />
                  </button>
                </div>
              </>
            ) : (
              /* No button here when no campaigns */
              <></>
            )}
          </div>
        </div>
        <div className="CreatedCampaigns mt-4">
          <ul className="nav nav-tabs">
            {Object.entries(statusTabs).map(([key, label]) => (
              <li className="nav-item" key={key}>
                <button
                  className={`nav-link ${activeTab === key ? "active" : ""}`}
                  onClick={() => setActiveTab(key)}
                  type="button"
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <span>{label}</span>

                  {/* Red Count Badge */}
                  {campaignStatusCounts[key] > 0 && (
                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        background: "#FF4949",
                        borderRadius: "50%",
                        color: "#fff",
                        fontSize: "9px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "500",
                        border: "2px solid white",
                        marginLeft: '6px',
                        marginTop: '2px',
                        fontFamily: 'Poppins,sans-serif'
                      }}
                    >
                      {campaignStatusCounts[key]}
                    </span>
                  )}
                </button>
              </li>
            ))}
          </ul>
          <div className="mt-3">
            <div className="row g-4">
              {dataList.length > 0 ? (
                dataList?.map((ele) => {
                  // Parse the timeline data for Instagram and YouTube content
                  let timeline = [];
                  try {
                    timeline = JSON.parse(ele.timeline || "[]");
                  } catch (err) {
                    console.error(
                      "Invalid JSON in timeline:",
                      ele.timeline,
                      err
                    );
                  }
                  // Check if Instagram content has more than 0
                  const instagramContent = timeline.some(
                    (entry) =>
                      entry.Instagram?.reels > 0 ||
                      entry.Instagram?.posts > 0 ||
                      entry.Instagram?.story > 0
                  );

                  // Check if YouTube content has more than 0
                  const youtubeContent = timeline.some(
                    (entry) =>
                      entry.YouTube?.shorts > 0 ||
                      entry.YouTube?.videos > 0 ||
                      entry.YouTube?.live_stream > 0
                  );
                  const cities = Array.isArray(ele.city)
                    ? ele.city
                    : typeof ele.city === "string"
                      ? [ele.city]
                      : [];

                  const states = Array.isArray(ele.state)
                    ? ele.state
                    : typeof ele.state === "string"
                      ? [ele.state]
                      : [];

                  // Combine city and state
                  const locations = cities.map((city, index) => ({
                    city,
                    state: states[index] || "", // Ensure state exists
                  }));

                  return (
                    <div
                      key={ele.campaign_id}
                      className="col-xl-3 col-lg-4 col-md-6"
                    >
                      <div className="campaign-card">
                        <div className="influencer-home-image">
                          <img
                            src={ele.campaign_poster || DummyImg}
                            alt={ele.campaign_title}
                            className="campaign-image w-100"
                          />
                        </div>
                        <div className="p-3">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div className="StatusCamp">
                              <Tooltip
                                title={
                                  ele?.campaign_title
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                  ele?.campaign_title?.slice(1)
                                }
                              >
                                <h5 className="mb-1 campaign-title">
                                  {ele?.campaign_title
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                    ele?.campaign_title?.slice(1)}
                                </h5>
                              </Tooltip>
                              <span
                                className={`status-badge status-${ele?.campaign_status
                                  ?.toLowerCase()
                                  .replace(/\s+/g, "-")}`}
                              >
                                {ele?.campaign_status}
                              </span>
                            </div>
                          </div>
                          <p className="mb-2">{ele.campaign_obj}</p>
                          <div className="d-flex align-items-center mb-2">
                            <span className="date-text text-black">
                              <Calendar
                                color="rgba(101, 101, 101, 1)"
                                size={15}
                              />
                              {formatSingleDate(ele.start_date)} -{" "}
                              {formatSingleDate(ele.end_date)}
                            </span>
                          </div>
                          {/* {locations.length > 0 && (
                                                 <img
                                                   src={LocationImg}
                                                   className="img-fluid me-1"
                                                   alt="location"
                                                 />
                                               )}
                   
                                               
                                               {states.slice(0, 3).map((state, index) => (
                                                 <span key={index} className="location-text ms-2">
                                                   {state}
                                                 </span>
                                               ))} */}

                          {/* State +count */}
                          {/* {states.length > 3 && (
                                                 <Tooltip title={states.slice(3).join(", ")} arrow>
                                                   <Chip
                                                     className="plus-count-chip"
                                                     style={{
                                                       fontSize: "11px",
                                                       fontFamily: "Poppins, sans-serif",
                                                       margin: "2px",
                                                       height: "25px",
                                                       width: "43px",
                                                       backgroundColor: "#6B8E76",
                                                       color: "#fff",
                                                       cursor: "pointer",
                                                     }}
                                                     label={`+${states.length - 3}`}
                                                     variant="outlined"
                                                   />
                                                 </Tooltip>
                                               )} */}
                          {/* <br /> */}
                          {/* Display first 3 cities */}
                          {/* {cities.slice(0, 3).map((city, index, arr) => (
                                                                        <span
                                                                          key={index}
                                                                          className="location-text mr-5"
                                                                        >
                                                                          {city}
                                                                          {index < arr.length - 1 ? ", " : ""}
                                                                        </span>
                                                                      ))} */}

                          {/* City +count */}
                          {/* {cities.length > 3 && (
                                                                        <Tooltip
                                                                          title={cities.slice(3).join(", ")}
                                                                          arrow
                                                                        >
                                                                          <Chip
                                                                            className="plus-count-chip"
                                                                            style={{
                                                                              fontSize: "11px",
                                                                              fontFamily: "Poppins, sans-serif",
                                                                              margin: "2px",
                                                                              height: "25px",
                                                                              width: "43px",
                                                                              backgroundColor: "#6B8E76",
                                                                              color: "#fff",
                                                                              cursor: "pointer",
                                                                            }}
                                                                            label={`+${cities.length - 3}`}
                                                                            variant="outlined"
                                                                          />
                                                                        </Tooltip>
                                                                      )} */}
                          <hr />
                          <div className="mb-3">
                            <div className="influencer-home-product">
                              Product Name
                            </div>
                            <div className="text-black">
                              {ele.product_name || "-"}
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="influencer-home-product">
                              Budget
                            </div>
                            <div className="text-black fw-medium">
                              {ele.budget || "-"}
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="influencer-home-product">
                              Deliverables
                            </div>
                            <div>
                              <div className="d-flex">
                                {(() => {
                                  const firstWeek =
                                    ele.timeline && ele.timeline.length > 0
                                      ? ele.timeline[0]
                                      : null;

                                  const hasInstagramContent =
                                    firstWeek &&
                                    firstWeek.Instagram &&
                                    (firstWeek.Instagram.reels > 0 ||
                                      firstWeek.Instagram.posts > 0 ||
                                      firstWeek.Instagram.story > 0);

                                  const hasYouTubeContent =
                                    firstWeek &&
                                    firstWeek.YouTube &&
                                    (firstWeek.YouTube.shorts > 0 ||
                                      firstWeek.YouTube.videos > 0 ||
                                      firstWeek.YouTube.live_stream > 0);

                                  return (
                                    <>
                                      {hasInstagramContent && (
                                        <div className="campaign-image-container me-3">
                                          <img
                                            src={instaDeliverables}
                                            alt="Instagram"
                                            className="social-media-icon-campaign"
                                          />
                                        </div>
                                      )}

                                      {hasYouTubeContent && (
                                        <div className="campaign-image-container">
                                          <img
                                            src={youtubeDeliverables}
                                            alt="YouTube"
                                            className="social-media-icon-campaign"
                                          />
                                        </div>
                                      )}
                                    </>
                                  );
                                })()}
                              </div>
                            </div>
                          </div>
                        </div>
                        <button onClick={() => ViewDetails(ele.campaign_id)}>
                          Campaign Details
                        </button>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="min-h-screen flex items-center justify-center bg-gray-50">
                  <div className="text-center px-4 max-w-md mx-auto">
                    <div>
                      <img
                        src={NoCamp}
                        alt="No Campaigns"
                        className="object-contain"
                      />
                    </div>
                    <>
                      <h2 className="Title">Welcome to the Campaign!</h2>
                      <p className="text-gray-600 mb-8">
                        It looks like you haven't created any campaigns yet.
                        Ready to launch your first one?
                      </p>
                      <button
                        onClick={() => createNavigate()}
                        className="CreateGreenBtn"
                      >
                        Create new Campaign
                        <img
                          src={create}
                          className="img-fluid"
                          alt="Create Icon"
                        />
                      </button>
                    </>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* <div>
              {loading ? (
                <p>Loading...</p>
              ) : error ? (
                <p className="text-danger">{error}</p>
              ) : (
                <ul className="list-group">
                  {(tabData[activeTab] || []).map((ele) => {
                    const timeline = JSON.parse(ele.timeline || "[]");

                    const instagramContent = timeline.some(
                      (entry) =>
                        entry.Instagram?.reels > 0 ||
                        entry.Instagram?.posts > 0 ||
                        entry.Instagram?.story > 0
                    );

                    const youtubeContent = timeline.some(
                      (entry) =>
                        entry.YouTube?.shorts > 0 ||
                        entry.YouTube?.videos > 0 ||
                        entry.YouTube?.live_stream > 0
                    );

                    const cities = Array.isArray(ele.city)
                      ? ele.city
                      : typeof ele.city === "string"
                      ? [ele.city]
                      : [];

                    const states = Array.isArray(ele.state)
                      ? ele.state
                      : typeof ele.state === "string"
                      ? [ele.state]
                      : [];

                    const locations = cities.map((city, index) => ({
                      city,
                      state: states[index] || "",
                    }));

                    return (
                      <div
                        key={ele.campaign_id}
                        className="col-xl-3 col-lg-4 col-md-6"
                      >
                        <div className="campaign-card">
                          <img
                            src={ele.campaign_poster || DummyImg}
                            alt={ele.campaign_title}
                            className="campaign-image w-100"
                          />
                          <div className="p-3">
                            <Tooltip title={ele.campaign_title}>
                              <h5 className="mb-1 campaign-title">
                                {ele.campaign_title}
                              </h5>
                            </Tooltip>

                            <p className="mb-2">{ele.campaign_obj}</p>

                            <div className="d-flex align-items-center mb-2">
                              <img
                                src={CalenderImg}
                                className="img-fluid me-2"
                                alt="calendar"
                              />
                              <span className="date-text">
                                {formatSingleDate(ele.start_date)} to{" "}
                                {formatSingleDate(ele.end_date)}
                              </span>
                            </div>

                            <div className="d-flex align-items-center mb-2">
                              {locations.length > 0 && (
                                <img
                                  src={LocationImg}
                                  className="img-fluid me-1"
                                  alt="location"
                                />
                              )}
                              {states.slice(0, 3).map((state, index) => (
                                <span
                                  key={index}
                                  className="location-text me-2"
                                >
                                  {state}
                                </span>
                              ))}
                              {states.length > 3 && (
                                <Tooltip
                                  title={states.slice(3).join(", ")}
                                  arrow
                                >
                                  <Chip
                                    className="plus-count-chip"
                                    style={{
                                      fontSize: "11px",
                                      fontFamily: "Poppins, sans-serif",
                                      margin: "2px",
                                      height: "25px",
                                      width: "43px",
                                      backgroundColor: "#6B8E76",
                                      color: "#fff",
                                      cursor: "pointer",
                                    }}
                                    label={`+${states.length - 3}`}
                                    variant="outlined"
                                  />
                                </Tooltip>
                              )}
                            </div>

                            <div className="d-flex mb-3">
                              {instagramContent && (
                                <img
                                  src={instagram}
                                  alt="Instagram"
                                  className="social-media-icon-campaign me-2"
                                />
                              )}
                              {youtubeContent && (
                                <img
                                  src={youtube}
                                  alt="YouTube"
                                  className="social-media-icon-campaign"
                                />
                              )}
                            </div>

                            <div className="language-container d-flex flex-wrap mt-2">
                              {ele.language &&
                                (() => {
                                  const visibleLanguages = ele.language.slice(
                                    0,
                                    3
                                  );
                                  const hiddenLanguages = ele.language.slice(3);

                                  return (
                                    <>
                                      {visibleLanguages.map((lang, index) => (
                                        <Tooltip
                                          key={index}
                                          title={lang.name}
                                          arrow
                                        >
                                          <span className="language-tag me-2">
                                            {lang.short_name}
                                          </span>
                                        </Tooltip>
                                      ))}
                                      {hiddenLanguages.length > 0 && (
                                        <Tooltip
                                          title={hiddenLanguages
                                            .map((lang) => lang.name)
                                            .join(", ")}
                                          arrow
                                        >
                                          <Chip
                                            style={{
                                              fontSize: "11px",
                                              fontFamily: "Poppins, sans-serif",
                                              margin: "2px 6px 5px 0",
                                              height: "25px",
                                              backgroundColor: "#6B8E76",
                                              color: "#fff",
                                              cursor: "pointer",
                                            }}
                                            label={`+${hiddenLanguages.length}`}
                                            variant="outlined"
                                          />
                                        </Tooltip>
                                      )}
                                    </>
                                  );
                                })()}
                            </div>

                            <button
                              onClick={() => ViewDetails(ele.campaign_id)}
                              className="btn btn-primary mt-3"
                            >
                              View Campaign
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </ul>
              )}
            </div> */}
          <div className="tab-content">
            <div className="row"></div>
          </div>
        </div>
      </div>
    </>
  );
}
